<template>
    <div>
        <admin-template>
            <div class="flex flex-col items-center justify-center min-h-[300px] bg-gray-50 p-4">                
                <!-- Début de la carte -->
                <div class="w-full max-w-sm bg-white rounded-2xl shadow-xl overflow-hidden border border-gray-100">
                    
                    <!-- En-tête coloré -->
                    <div class="h-24 bg-gradient-to-r from-orange-500 to-red-600"></div>
                    
                    <div class="px-6 pb-6 relative">
                        <!-- Avatar centré qui chevauche l'en-tête -->
                        <div class="absolute -top-32 left-1/2 transform -translate-x-1/2">
                            <img class="h-24 w-24 rounded-full border-4 border-white shadow-md object-cover" 
                            src="https://wallpapers.com/images/hd/generic-male-avatar-icon-piiktqtfffyzulft.jpg" 
                            alt="Avatar">
                        </div>
                        
                        <!-- Texte -->
                        <div class="mt-14 text-center">
                            <p class="text-xs font-semibold tracking-wide text-gray-400 uppercase mb-1">
                                <div class="w-2.5 h-2.5 bg-green-500 rounded-full inline-block mr-1"></div> Connecté
                            </p>
                            <h3 class="text-xl font-bold text-gray-800">{{ $account.account.prenom + ' ' + $account.account.nom }}</h3>
                            <p class="text-gray-500 text-sm mb-6">Administrateur</p>
                            
                            <!-- Actions -->
                            <div class="flex gap-3 justify-center">
                                <!-- <button @click="logout" class="px-4 py-2 bg-red-50 text-red-600 rounded-lg text-sm font-medium hover:bg-red-100 hover:text-red-700 transition-colors flex items-center gap-2">
                                    <span>Déconnexion</span>
                                    <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
                                    </svg>
                                </button> -->
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Fin de la carte -->
                
            </div>
        </admin-template>
    </div>
</template>

<script>
export default {
    methods: {
        logout() {
            localStorage.removeItem('auth-token');
            window.location.href = '/login';
        }
    },
}
</script>

<style lang="scss" scoped>

</style>